import { useEffect, useState } from 'react';
import useDynamicImageLoading from '../../hooks/useDynamicImageLoading';
import ShowIf from '../../components/UI/ShowIf';
import SplashScreenLoading from '../../components/SplashScreenLoading/SplashScreenLoading';
import BaseEditor from '../BaseEditor/BaseEditor';
import { PORTADA_LIBRO_SETTINGS } from '../../settings/PortadaLibroSettings';
import {EX_LIBRIS_SETTINGS} from "../../settings/ExLibrisSettings";

const galleriesBasePath: any = {
  fondos: `images/fondos/`,
  texturas: `images/texturas/`,
  detalles: `images/libros/detalles/`,
  ilustraciones: `images/libros/ilustraciones/`,
  titulos: `images/libros/titulos/`,
};

function PortadaLibro() {
  const selectedCategorySettings = PORTADA_LIBRO_SETTINGS;
  const [settings, setSettings] = useState<any>(null);
  const [loadingImages, updatedSelectedCategorySettings] = useDynamicImageLoading(
      selectedCategorySettings,
      galleriesBasePath
  );

  useEffect(() => {
    if (loadingImages) {
      return;
    }

    setSettings(updatedSelectedCategorySettings);
  }, [loadingImages]);

  return (
    <ShowIf condition={!!settings} elseChildren={<SplashScreenLoading />}>
      <BaseEditor  workArea={{ height: 901, width: 633 }} selectedCategorySettings={settings} />
    </ShowIf>
  );
}

export default PortadaLibro;
